<template>

  <div class="page_container">
      <div class="get_yinbi_item_container">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">网络错误</div>
            
            
        </div>

        
        
        

      </div>



  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >


 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    
  }

  .get_yinbi_item_container{
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    background: #ededed;
    border-radius: 0.3rem;
    width: 98%;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    margin-bottom: 0.4rem;
    
  }

  .get_yinbi_item_left{
    display: flex;
    flex: 3;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    margin: 0.1rem 0.2rem;

    
    
  }

  .get_yinbi_item_img{
    display: flex;
    flex: 2;
    
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    justify-content: center;
    
  }
  .get_yinbi_item_img img{
    width: 40%;
  }

  .get_yinbi_item_text_a{
    font-size: 0.7rem;
    margin-bottom: 0.1rem;
    
  }

  .get_yinbi_item_text_b{
    font-size: 0.4rem;
    color: #848488;
    margin-top: 0.1rem;
    
  }

  .get_yinbi_item_text_c{
    font-size: 0.5rem;
    
    margin-top: 0.3rem;
    padding: 0.1rem 1rem;
    border: 0.04rem solid #1296db;
    border-radius: 0.3rem;
    margin-bottom: 0.1rem;
    margin-top: 0.3rem;
  }

  .get_yingbi_intro{
    display: flex;
    flex-direction: column;
    
    justify-content: left;

    margin-top: 0.5rem;
  }


  .get_yingbi_intro_item{
    display: flex;
    flex-direction: column;

    margin-bottom: 0.5rem;
    
    
    margin-left: 0.3rem;
    
  }

    
    
  .get_yingbi_intro_item_title{
    font-size: 0.4rem;
    
    margin-bottom: 0.1rem;
    color: #000000;
    text-align: left;
    
  }
  .get_yingbi_intro_item_main_body{
    font-size: 0.4rem;
    color:#848488;
    margin-bottom: 0.1rem;
    
    
    text-align: left;
  }



  

  






  </style>